import Vue from 'vue';
// vue官方推荐 https://cn.vuejs.org/guide/scaling-up/state-management.html#pinia
/**
 * store的持久化缓存策略
 * 不经常改变的可以设置缓存
 * 缓存清除列举：
 * 1、退出登陆时(主动/被动）立刻重置store数据，缓存清除
 * 2、切换国家/语言时立刻清除部分数据（权限相关的）
 * 3、硬性重新加载/强制刷新(Ctrl 或 Shift + F5，Ctrl + Shift + R)，浏览器时会重制store数据，并重载浏览器
 * 4、单独按F5时重置store数据，但不重载浏览器
 * 5、expiration设置缓存时间；默认7天
 */

import { createPinia, PiniaVuePlugin } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import useAppStore from '@/store/modules/app';
import useMenuStore from '@/store/modules/menu';

export { default as useAppStore } from './modules/app';
export { default as useMenuStore } from './modules/menu';

const expirationKey = 'gattaran-workshop-store-expiration';
let eventListenerFlag = false; //
// 模块拆分
export function useStore() {
  const app = useAppStore();
  const menu = useMenuStore();
  // 退出登陆时重置store的数据
  const reset = () => {
    app.$reset();
    menu.$reset();
    localStorage.removeItem(expirationKey);
  };
  const eventListener = () => {
    if (eventListenerFlag) return;
    console.log('--> 强制刷新可以重置store数据 Meta/Command + shift + r or ctrl + shift + r');
    document.addEventListener('keydown', (e) => {
      const inMac = e.metaKey && e.shiftKey && e.key === 'r';
      const inWin = (e.ctrlKey && e.shiftKey && e.key === 'r') || (e.shiftKey && e.key === 'F5');
      if (inMac || inWin) {
        console.log('Meta + Shift + r or ctrl + Shift + r');
        reset();
      }
      // 仅清除store，不进行刷新。F5
      const noSpecialKey = !(e.shiftKey && e.ctrlKey && e.metaKey && e.altKey);
      if (e.key === 'F5' && noSpecialKey) {
        reset();
      }
      eventListenerFlag = true;
    });
  };
  return {
    app,
    menu,
    loginOut: reset,
    // 切换国家时重置部分数据
    switch() {
      app.switchCountry();
      menu.switchCountry();
      // reset();
    },
    eventListener,
    // 设置缓存时间 单位 天
    expiration(day = 7) {
      const expiration = localStorage.getItem(expirationKey);
      if (expiration) {
        const nowTime = new Date().getTime();
        if (nowTime > +expiration) {
          console.log('store缓存过期');
          reset();
        }
      } else {
        const expirationTime = new Date().getTime() + day * 24 * 60 * 60 * 1000;
        localStorage.setItem(expirationKey, expirationTime + '');
      }
    },
  };
}

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
Vue.use(pinia);
export default pinia;
